var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.081 11.6313C12.3681 12.6103 11.2134 13.248 9.91242 13.248H8.08692C7.45631 13.248 6.91929 12.8476 6.71594 12.2873C6.46493 12.2124 6.21878 12.1152 5.97858 11.9959C5.46991 11.7431 5.00803 11.4007 4.60145 10.9766C1.96411 11.556 -0.00976562 13.9059 -0.00976562 16.7173V17.0848C-0.00976562 17.59 0.399756 17.9995 0.904903 17.9995H15.0961C15.6013 17.9995 16.0108 17.59 16.0108 17.0848V16.7173C16.0108 14.5455 14.8328 12.649 13.081 11.6313Z",
    fill: "#EF6C00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.62939 9.09179C4.02251 9.09179 4.36468 8.87391 4.54195 8.55238C4.54661 8.5651 4.55135 8.57775 4.55612 8.5904C4.55753 8.5942 4.55894 8.598 4.56035 8.6018C4.97622 9.69644 5.78539 10.6141 6.85239 11.015C7.11045 10.605 7.56676 10.3323 8.08706 10.3323H9.91256C10.0947 10.3323 10.2641 10.2809 10.4127 10.1979C10.6622 10.0583 10.8866 9.70439 11.0025 9.51678C11.1879 9.21655 11.3316 8.89854 11.4589 8.55183C11.5305 8.68184 11.629 8.79493 11.7469 8.88354V9.33117C11.7469 10.3426 10.924 11.1656 9.91252 11.1656H8.08702C7.74192 11.1656 7.46213 11.4453 7.46213 11.7904C7.46213 12.1356 7.74192 12.4153 8.08702 12.4153H9.91252C11.6131 12.4153 12.9967 11.0318 12.9967 9.33117V8.88354C13.2497 8.69351 13.4133 8.39104 13.4133 8.05032V6.16605V5.44349C13.4133 5.09576 13.2428 4.78809 12.9809 4.59892C12.7778 2.02905 10.6218 0 8.0006 0C5.3794 0 3.22336 2.02905 3.02028 4.59888C2.75843 4.78805 2.58789 5.09576 2.58789 5.44345V8.05025C2.58789 8.62709 3.0565 9.09179 3.62939 9.09179ZM8.0006 1.24983C9.94099 1.24983 11.5414 2.73269 11.7285 4.62472C11.6057 4.72132 11.5051 4.84479 11.4358 4.98647C10.8461 3.44808 9.52987 2.37701 8.00056 2.37701C6.43829 2.37701 5.14311 3.48489 4.56764 4.98032C4.56685 4.98236 4.56611 4.98443 4.56533 4.98651C4.49602 4.84483 4.39542 4.72136 4.27261 4.62476C4.45979 2.73269 6.06021 1.24983 8.0006 1.24983Z",
    fill: "#EF6C00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminOrange);
export default __webpack_public_path__ + "static/media/admin-orange.e2a63bff3bf99d6d4b2cb1a9d0c09ca4.svg";
export { ForwardRef as ReactComponent };